import React, { useState, useEffect, useContext } from 'react'
import {useLocation} from 'react-router-dom';

import i18next from "i18next";
import cookies from "js-cookie";
import LanguageContext from "./../../store/language-context";
import { useTranslation } from "react-i18next";

export default function Intro() {

  const languageCtx = useContext(LanguageContext);

    const { t } = useTranslation();


  useEffect(() => {
   
  },[languageCtx.languageCode])
 

  return (
  <div className="container section2">
    <div className="row align-items-start">
      <div className="col-12 col-sm-12 col-m-6 col-lg-6">
        <div className="container">
          <h2>{t("Εισαγωγή")}</h2>
          <p>Παλεύοντας με τα μελτέμια, χρόνια, θα κουράστηκε.<br/>Ισχνός εβδομηντάρης, τώρα, μας φιλοξενεί,<br/>εντελώς αμίλητος, ο Άγιος στο μικρό <br/>θολωτό δωμάτιοπου του χάρισαν. <br/>Κατεβαίνει τηνύχτα ο Γαλαξίας πάνω στη στέγη του <br/>πέφτουν τ΄αστέρια στη μικρή καμπάνα, πλησιάζουν <br/>το πρόσωπο του φίλου μου που κοιμάται <br/>με μιαχρωματιστή Φολέγανδρο αγκαλιά. <br/>Ν΄ ανέβω, λέω,στην εκκλησιά – θα με σηκώσει ο άνεμος – για να μαζέψω αστέρια. <br/>Το καλλίτερο θατο κρατήσω φυλαχτό.  <br/>Κ. Γαρίδης Φολέγανδρος <br/>Εκδόσεις Κούρος,1966  <br/></p><p>Η Φολέγανδρος είναι ένα βραχώδες νησί μεέδαφος άγονο. Ο χειμώνας δίνει λιγοστές βροχές και οι θυελλώδεις άνεμοιαποτελούν ένα συχνό καιρικό φαινόμενο. Φυτά, ζώα και άνθρωποι μοχθούνκαθημερινά για να καταφέρουν να ζήσουν. Οι Φολεγανδρίτες, ακούραστοι εργάτεςτης γης, είναι άνθρωποι φιλήσυχοι, ευγενικοί και φιλόξενοι παρόλο που ο τόποςτους είναι τραχύς. Τα μονοπάτια και οι λιθόστρωτοι οδοί της Φολεγάνδρουαποτελούσαν από την αρχαιότητα το βασικότερο σύστημα πρόσβασης των κατοίκωνμεταξύ των οικισμών και των χώρων αγροτικής και κτηνοτροφικής δραστηριότητας.Στο παρόν, η περιήγηση σε αυτά φιλοδοξεί να αποτελέσει ένα δίδαγμα σχετικά μετη σημαντικότητα της λιτής αφθονίας και να αναδείξει έναν απέριττο τρόπο ζωήςπου σέβεται το περιβάλλον και το συνάνθρωπο.</p>
        </div>
      </div>
     </div>
    </div>
  )
}